import { TableProps } from '@amzn/awsui-components-react-v3/polaris/table/interfaces';
import { isValidWorkspace } from 'src/commons/validationUtils';
import { createGroupDetailLink, createWorkspaceDetailLink, createWSPermissionLFLink } from 'src/routes';
import React from 'react';
import { Link } from 'src/components/common/Link';

export const tagsColumnDefinitions: TableProps.ColumnDefinition<any>[] = [
  {
    id: 'Workspace',
    header: 'Workspace',
    cell: (e) => (
      <Link
        href={
          isValidWorkspace(e.Workspace) ? createWorkspaceDetailLink(e.Workspace) : createGroupDetailLink(e.Workspace)
        }
      >
        {e.Workspace}
      </Link>
    ),
    minWidth: 200,
    sortingField: 'Workspace',
  },
  {
    id: 'TagId',
    header: 'Tag',
    cell: (e) => e.Tag,
    minWidth: 200,
    sortingField: 'TagId',
  },
  {
    id: 'Type',
    header: 'Tag type',
    cell: (e) => e.TagType,
    minWidth: 200,
    sortingField: 'Type',
  },
  {
    id: 'Permission',
    header: 'Permissions',
    cell: (e) => e.Permission,
    minWidth: 200,
    sortingField: 'Permission',
  },
  {
    id: 'Status',
    header: 'Status',
    cell: (e) => e.Status,
    minWidth: 200,
    sortingField: 'Status',
  },
  {
    id: 'Reason',
    header: 'Reason',
    cell: (e) => e.Reason,
    minWidth: 200,
    sortingField: 'Reason',
  },
];
export const resourceColumnDefinitions: TableProps.ColumnDefinition<any>[] = [
  {
    id: 'dataPermissionId',
    header: 'Data permission ID',
    cell: (item) => <Link href={createWSPermissionLFLink(item.dataPermissionId)}>{item.dataPermissionId}</Link>,
    minWidth: 100,
    sortingField: 'dataPermissionId',
  },
  {
    id: 'dataPermissionType',
    header: 'Permission type',
    cell: (item) => item.permissionType,
    minWidth: 150,
    sortingField: 'permissionType',
  },
  {
    id: 'workspace',
    header: 'Owner',
    cell: (item) => (
      <Link
        href={
          isValidWorkspace(item.workspace)
            ? createWorkspaceDetailLink(item.workspace)
            : createGroupDetailLink(item.workspace)
        }
      >
        {item.workspace}
      </Link>
    ),
    minWidth: 100,
    sortingField: 'workspace',
  },
  {
    id: 'dataLakePrincipal',
    header: 'DataLake principal',
    cell: (item) => item.dataLakePrincipal,
    minWidth: 200,
    sortingField: 'dataLakePrincipal',
  },
  {
    id: 'catalogId',
    header: 'Catalog',
    cell: (item) => item.catalogId,
    minWidth: 200,
    sortingField: 'catalogId',
  },
  {
    id: 'databaseName',
    header: 'Database name',
    cell: (item) => item.databaseName,
    minWidth: 200,
    sortingField: 'databaseName',
  },
  {
    id: 'tableName',
    header: 'Table name',
    cell: (item) => (item.tableName != undefined ? item.tableName : 'All Tables'),
    minWidth: 200,
    sortingField: 'tableName',
  },
  {
    id: 'fgapName',
    header: 'Fine grain policy',
    cell: (item) => (item.fgapName != undefined ? item.fgapName : ''),
    minWidth: 200,
    sortingField: 'fgapName',
  },
  {
    id: 'status',
    header: 'Status',
    cell: (item) => item.status,
    minWidth: 200,
    sortingField: 'status',
  },
  {
    id: 'statusReason',
    header: 'Reason',
    cell: (item) => item.statusReason,
    minWidth: 200,
    sortingField: 'statusReason',
  },
];
export const DEFAULT_CANCEL_REASON = 'User cancel from workspace access page';
